let canvasGlob: HTMLCanvasElement | null = null;

/**
 * Uses canvas.measureText to compute and return the width of the given text of given font in pixels.
 *
 * @param {String} text The text to be rendered.
 * @param {String} font The css font descriptor that text is to be rendered with (e.g. "bold 14px verdana").
 *
 * @see https://stackoverflow.com/questions/118241/calculate-text-width-with-javascript/21015393#21015393
 */
export const getWidth = (text: string, font: string) => {
  if (typeof document === 'undefined') {
    return 0;
  }
  if (!canvasGlob) {
    canvasGlob = document.createElement('canvas');
  }

  const context = canvasGlob?.getContext('2d');
  if (context) {
    context.font = font;
    const metrics = context?.measureText(text);
    return metrics.width;
  }
};

const getCssStyle = (currentElement: Element, prop: string) => {
  if (typeof window === 'undefined') return;
  return window?.getComputedStyle(currentElement, null).getPropertyValue(prop);
};

export const getCanvasFont = (el?: HTMLElement) => {
  if (typeof document === 'undefined') {
    return 'normal 14px Assistant';
  }
  const element = el || document.body;
  const fontWeight = getCssStyle(element, 'font-weight') || 'normal';
  const fontSizeStyle = getCssStyle(element, 'font-size') || '14px';
  const fontFamily = getCssStyle(element, 'font-family') || 'Assistant';

  return `${fontWeight} ${fontSizeStyle} ${fontFamily}`;
};

export default {
  getWidth,
  getCanvasFont,
};
